var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "card" }, [
      _vm._m(0),
      _vm._v(" "),
      _c("div", { staticClass: "card-body" }, [
        _c("div", { staticClass: "flex flex_gap" }, [
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "" } }, [_vm._v("Период (c 11.12)")]),
            _vm._v(" "),
            _c("div", [_c("DateRangePicker", { ref: "range" })], 1),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "form-group" }, [
            _c("label", { attrs: { for: "" } }, [_vm._v("Мин.пауза (минут)")]),
            _vm._v(" "),
            _c("input", {
              directives: [
                {
                  name: "model",
                  rawName: "v-model",
                  value: _vm.minPause,
                  expression: "minPause",
                },
              ],
              staticClass: "form-control",
              attrs: { type: "number" },
              domProps: { value: _vm.minPause },
              on: {
                input: function ($event) {
                  if ($event.target.composing) return
                  _vm.minPause = $event.target.value
                },
              },
            }),
          ]),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group" },
            [
              _c("label", { attrs: { for: "" } }, [_vm._v("Группы")]),
              _vm._v(" "),
              _c("CustomMultiSelect", {
                ref: "selectedGroup",
                attrs: { records: _vm.getGroupsByUser() },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "form-group flex-grow-1" },
            [
              _c("label", { attrs: { for: "" } }, [_vm._v("Пользователи")]),
              _vm._v(" "),
              _c("CustomMultiSelect", {
                ref: "selectedUsers",
                attrs: { records: _vm.usersForSelect ?? _vm.users },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "align-self-end action_btns" },
            [
              _c("LoadingButton", {
                attrs: {
                  title: "Сбросить",
                  loading: _vm.loading,
                  color: _vm.$constants.LOADING_COLOR,
                  onClick: () => _vm.getRecords(true),
                  className: "btn btn-outline-info",
                },
              }),
              _vm._v(" "),
              _c("LoadingButton", {
                attrs: {
                  title: "Показать",
                  loading: _vm.loading,
                  color: _vm.$constants.SUCCESS_COLOR,
                  onClick: () => _vm.getRecords(),
                  className: "btn btn-outline-success",
                },
              }),
            ],
            1
          ),
        ]),
      ]),
    ]),
    _vm._v(" "),
    _vm.loading || _vm.records
      ? _c("div", { staticClass: "card" }, [
          _c(
            "div",
            { staticClass: "card-body" },
            [
              _c("pulse-loader", {
                staticClass: "text-center",
                attrs: {
                  loading: _vm.loading,
                  color: _vm.$constants.LOADING_COLOR,
                },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex flex_gap_10" },
                _vm._l(_vm.filter.options, function (o) {
                  return _c(
                    "button",
                    {
                      class: {
                        "btn btn-outline-primary": true,
                        active: _vm.filter.current.type === o.type,
                      },
                      attrs: { type: "button" },
                      on: {
                        click: function ($event) {
                          return _vm.changeFilter(o)
                        },
                      },
                    },
                    [_vm._v(_vm._s(o.alias) + "\n        ")]
                  )
                }),
                0
              ),
              _vm._v(" "),
              _c("div", { staticClass: "table_div_block" }, [
                _c(
                  "table",
                  {
                    staticClass:
                      "table table-sm table-hover mt-1 table-bordered",
                  },
                  [
                    _c("thead", { staticClass: "fs-12" }, [
                      _c(
                        "tr",
                        [
                          _c("th", { staticClass: "def_width" }),
                          _vm._v(" "),
                          _vm._l(_vm.selectedUsers, function (u) {
                            return _vm.hasRecords(u.id)
                              ? _c("th", { staticClass: "text-wrap" }, [
                                  _vm._v(_vm._s(u.id) + " " + _vm._s(u.name)),
                                ])
                              : _vm._e()
                          }),
                        ],
                        2
                      ),
                      _vm._v(" "),
                      _c(
                        "tr",
                        [
                          _c("th", { staticClass: "def_width" }),
                          _vm._v(" "),
                          _vm._l(_vm.selectedUsers, function (u) {
                            return _vm.hasRecords(u.id)
                              ? _c("th", [
                                  _c(
                                    "div",
                                    {
                                      staticClass: "flex flex_gap_10 flex-wrap",
                                    },
                                    _vm._l(
                                      _vm.getGroupsByUser(u.id),
                                      function (g) {
                                        return _c(
                                          "span",
                                          {
                                            staticClass:
                                              "badge badge-primary pointer",
                                            on: {
                                              click: function ($event) {
                                                return _vm.selectGroup(g.id)
                                              },
                                            },
                                          },
                                          [
                                            _vm._v(
                                              _vm._s(g.title) +
                                                " " +
                                                _vm._s(g.projects)
                                            ),
                                          ]
                                        )
                                      }
                                    ),
                                    0
                                  ),
                                ])
                              : _vm._e()
                          }),
                        ],
                        2
                      ),
                    ]),
                    _vm._v(" "),
                    _c(
                      "tbody",
                      [
                        _c(
                          "tr",
                          [
                            _c("td", { staticClass: "fixed-side" }, [
                              _vm._v("минуты/смены"),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.selectedUsers, function (u) {
                              return _vm.hasRecords(u.id)
                                ? _c("td", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.totalShifts[u.id]
                                            ?.total_duration ?? 0
                                        ) +
                                        " (" +
                                        _vm._s(
                                          _vm.totalShifts[u.id]?.total_shifts ??
                                            0
                                        ) +
                                        ")\n            "
                                    ),
                                  ])
                                : _vm._e()
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _c(
                          "tr",
                          [
                            _c("td", { staticClass: "fixed-side" }, [
                              _vm._v("паузы/%"),
                            ]),
                            _vm._v(" "),
                            _vm._l(_vm.selectedUsers, function (u) {
                              return _vm.hasRecords(u.id)
                                ? _c("td", [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(_vm.totalDatByUserId(u.id)) +
                                        " (" +
                                        _vm._s(
                                          _vm.totalDatByUserId(u.id, false)
                                        ) +
                                        "%)\n            "
                                    ),
                                  ])
                                : _vm._e()
                            }),
                          ],
                          2
                        ),
                        _vm._v(" "),
                        _vm._l(_vm.records, function (r, date) {
                          return _c(
                            "tr",
                            [
                              _c("td", { staticClass: "fixed-side" }, [
                                _vm._v(
                                  _vm._s(_vm.printDate(date, "DD.MM.YYYY"))
                                ),
                              ]),
                              _vm._v(" "),
                              _vm._l(_vm.selectedUsers, function (u) {
                                return _vm.hasRecords(u.id)
                                  ? [
                                      _c("td", {}, [
                                        (r[u.id] ?? []).filter((d) => d.status)
                                          .length
                                          ? _c(
                                              "div",
                                              {
                                                staticClass: "flex flex_gap_10",
                                              },
                                              [
                                                _c(
                                                  "v-popover",
                                                  {
                                                    attrs: {
                                                      trigger: "click",
                                                      popoverClass:
                                                        "activity_list_popover",
                                                      popoverInnerClass:
                                                        "popover_content",
                                                      "auto-hide": true,
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "div",
                                                      {
                                                        staticClass: "pointer",
                                                      },
                                                      [
                                                        _c(
                                                          "span",
                                                          {
                                                            staticClass:
                                                              "badge badge-info",
                                                          },
                                                          [
                                                            _vm._v(
                                                              _vm._s(
                                                                r[u.id].filter(
                                                                  (d) =>
                                                                    d.status
                                                                ).length
                                                              )
                                                            ),
                                                          ]
                                                        ),
                                                      ]
                                                    ),
                                                    _vm._v(" "),
                                                    _c(
                                                      "template",
                                                      { slot: "popover" },
                                                      _vm._l(
                                                        r[u.id],
                                                        function (d) {
                                                          return d.status
                                                            ? _c("p", [
                                                                _vm._v(
                                                                  "\n                        " +
                                                                    _vm._s(
                                                                      _vm.printDate(
                                                                        d.date_start,
                                                                        "HH:mm",
                                                                        3
                                                                      )
                                                                    ) +
                                                                    " - " +
                                                                    _vm._s(
                                                                      _vm.printDate(
                                                                        d.date_end,
                                                                        "HH:mm",
                                                                        3
                                                                      )
                                                                    ) +
                                                                    " (" +
                                                                    _vm._s(
                                                                      _vm.printDiff(
                                                                        d
                                                                      )
                                                                    ) +
                                                                    ")\n                      "
                                                                ),
                                                              ])
                                                            : _vm._e()
                                                        }
                                                      ),
                                                      0
                                                    ),
                                                  ],
                                                  2
                                                ),
                                                _vm._v(" "),
                                                _c("span", [
                                                  _vm._v(
                                                    "(" +
                                                      _vm._s(
                                                        _vm.getTotalDuration(
                                                          r[u.id]
                                                        )
                                                      ) +
                                                      ")"
                                                  ),
                                                ]),
                                              ],
                                              1
                                            )
                                          : _vm._e(),
                                      ]),
                                    ]
                                  : _vm._e()
                              }),
                            ],
                            2
                          )
                        }),
                      ],
                      2
                    ),
                  ]
                ),
              ]),
            ],
            1
          ),
        ])
      : _vm._e(),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "card-header" }, [
      _c("h5", [_vm._v("Паузы по активности")]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }